<template>
    <div class="modal" :class="{ 'open_modal': showAttachmentModal}">
    <div class="modal_overlay"></div>
    <div class="modal_inner max_height_80">
        <div class="modal_header"> 
            <span class="close_icon close_icon_sm" @click="closeAttachmentModal()">×</span>
            <h2>{{ $t('special_lecture.download') }}</h2>
        </div>
        <div class="modal_wrapper ">
            <div class="modal_content modal_1080p">
                <div class="file_modal" v-if="lectureAttachments && lectureAttachments.length > 0">
                    <div class="inner" v-for="(file, fileIndex) in lectureAttachments" :key="'item_'+fileIndex">
                        <button type="button" class="downlaod btn " @click.prevent="downLoadAttachment(file, file.title, file.ext)" :title="file.title"><i class="lni-download"></i></button>
                        <div class="content">
                            <template v-if="['gif', 'png', 'jpg', 'jpeg', 'JPG'].includes(file.ext)">
                                <img :src="file.image_path" alt="" :title="file.title"> 
                            </template>
                            <template v-if="['pdf'].includes(file.ext)">
                                <embed :src="file.image_path"> 
                            </template>
                            <template v-if="['xls','xlsx','xlm','xla','xlc','xlt','xlw','csv'].includes(file.ext)">
                                <i class="fas fa-file-excel fa-10x"  :title="file.title"></i>
                            </template>
                            <template v-if="['docx'].includes(file.ext)">
                                <i class="fas fa-file-word fa-10x"  :title="file.title"></i>
                            </template>
                            <template v-if="['zip'].includes(file.ext)">
                                <i class="fas fa-file-archive fa-10x"  :title="file.title"></i>
                            </template>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
    export default {
        name:'lecture-attachment-modal',
        data(){
            return{
                
            }
        },
        props:{
            showAttachmentModal:{
                type: Boolean,
                required: true
            },
            lectureAttachments:{
                type: Array,
                required: true
            },
        },
        created() {
            
        },  
        updated(){
            
        },
        methods:{
            closeAttachmentModal(){
                this.$emit("closeModal");
            },
            async downLoadAttachment(file, title, extension){
                await this.axios.get('/attachment-download-file/' + file.id, {responseType: 'arraybuffer',})
                .then(({data}) => {
                    const fileName = title + '.' + extension
                    this.fileDownload(data, fileName)
                })
            },
            fileDownload(data, filename) {
                const url = window.URL.createObjectURL(new Blob([data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
            },
        }
    }
</script>

<style lang="scss" scoped>

    .modal_inner .close_icon{
        position: absolute;
        top: -15px;
        right: -15px;
        overflow: hidden;
        cursor: pointer;
        z-index: 5;
        padding: 0.2rem 0.62rem;
        box-shadow: 0px 4px 24px 0px rgb(34 41 47 / 10%);
        border-radius: 4px;
        background: #fff;
        font-size: 2rem;
        font-weight: 400;
        line-height: 1;
        transition: all 0.3s;
    }
    .close_icon::before, .close_icon::after {
        background: #fff;
    }

    .issue-date{
        margin-top: 10px;
    }

    .file_modal {
        display: flex;
        margin-left: -5px;
        margin-right: -5px;
        flex-wrap: wrap;
        padding-right: 10px;

    }
    .inner {
        position: relative;
        width: 33.3333%;
        padding-left: 5px;
        padding-right: 5px;
        margin-bottom: 10px;
        padding-top: 20px;
        .content{
            display: inline-block;
            width: 100%;
            position: relative;
            background-position: center;
            background-size: 100%;
            min-height: 200px;
            max-height: 200px;
            line-height: 150px;
            text-align: center;
            cursor: pointer;
            object , embed  , iframe , img {
                position: absolute;
                top: 50%;
                left: 50%;
                width: auto;
                height: auto;
                min-width: auto;
                min-height: auto;
                max-width: 100%;
                max-height: 100%;
                vertical-align: middle;
                transform: translate(-50%,-50%);
                z-index: 1;
            }
        }
        .downlaod {
            top: 0px;
            left: 5px;
            position: absolute;
            padding: 0;
            box-shadow: none;
        }
    }
</style>